import * as React from 'react';

// Component
interface IProps {
    children: React.ReactNode | Array<React.ReactNode>;
    style?: React.CSSProperties;
}

class ScrollHandler extends React.Component<IProps> {
    ref: HTMLDivElement;

    isLockedToBottom = true;

    componentDidMount() {
        if (this.isLockedToBottom) {
            this.scrollToBottom();
        }
    }

    componentDidUpdate() {
        if (this.isLockedToBottom) {
            this.scrollToBottom();
        }
    }

    scrollToBottom() {
        this.ref.scrollTop = this.ref.scrollHeight;
    }

    handleRef = (ref: HTMLDivElement) => {
        this.ref = ref;
    }

    handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        if (!this.isLockedToBottom) {
            if (e.currentTarget.scrollTop >= (e.currentTarget.scrollHeight - e.currentTarget.offsetHeight)) {
                this.isLockedToBottom = true;
            }
        } else {
            if (e.currentTarget.scrollTop < (e.currentTarget.scrollHeight - e.currentTarget.offsetHeight)) {
                this.isLockedToBottom = false;
            }
        }
    }

    render() {
        return (
            <div ref={this.handleRef} style={{ ...this.props.style }} onScroll={this.handleScroll}>
                {this.props.children}
            </div>
        );
    }
}

export default ScrollHandler;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ScrollHandler/ScrollHandler.tsx